export const DEFAULT_REDIRECT = 'https://www.jeep.com/incentives/military-incentive.html'; // Yes this is supposed to be the same as the jeep redirect
export const CHRYSLER_REDIRECT = 'https://www.chrysler.com/incentives/military-incentive.html';
export const DODGE_REDIRECT = 'https://www.dodge.com/incentives/military-incentive.html';
export const JEEP_REDIRECT = 'https://www.jeep.com/incentives/military-incentive.html';
export const RAM_REDIRECT = 'https://www.ramtrucks.com/incentives/military-incentive.html';
export const FIAT_REDIRECT = 'https://www.fiatusa.com/incentives/military-incentive.html';
export const ALFA_REDIRECT = 'https://www.alfaromeousa.com/military-incentive';
